import { EMPTY_OBJ, EMPTY_ARR } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useLocationsList = (queryVariables = {}, queryConfig = {}) => {
  const { data: locations = [], ...queryResult } = useResourceList(
    { name: 'locations', api: api.locations },
    queryVariables,
    queryConfig,
  );

  return {
    locations,
    latestLocations: queryResult.latestData,
    ...queryResult,
  };
};

export const useLocation = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['location', { id }], api.locations.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    location: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useLocationsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['locations', { ids }], api.locations.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    locations: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'locations' });

export const useDeleteLocation = createMutation(api.locations.remove);

export const useCreateLocation = createMutation(api.locations.create);

export const useSaveLocation = createMutation(api.locations.save);

export const useUpdateLocation = createMutation(api.locations.update);
